module.exports = __webpack_public_path__ + "static/element-icons.535877f.woff";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 227
// module chunks = 1